import React, { useEffect, useState, useImperativeHandle, forwardRef, } from "react";

import { Box, Button, Typography } from "@mui/material";
import { CollapseDetail } from "./CollapseDetail/CollapseDetail";
import { ChannelDetailForm } from "./Forms/ChannelDetailForm/ChannelDetail";
import { SourceForm } from "./Forms/SourceForm/SourceForm";
import { TargetForm } from "./Forms/TargetForm/TargetForm";
import { useDispatch, useSelector } from "react-redux";
import { createChannel } from "../../Store/Features/SingleChannel/SingleChannelSlice";
import "./Detail.css";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { validator } from "../../Utils/FieldValidator/FieldValidator";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../../Store/Features/Users/UserSlice";


export const Detail = forwardRef((props, ref) => {
  const role = localStorage.getItem("role");
  const dispatch = useDispatch();
  const [channelName, setChannelName] = useState({
    value: "", error: ""
  });
  const [srcName, setSrcName] = useState({
    value: "", error: ""
  });
  const [srcApiKeyName, setSrcApiKeyName] = useState({
    value: "", error: ""
  });
  const [srcApiKey, setSrcApiKey] = useState({
    value: "", error: ""
  });
  const [trgName, setTrgName] = useState({
    value: "", error: ""
  });
  const [trgApiKeyName, setTrgApiKeyName] = useState({
    value: "", error: ""
  });
  const [trgApiKey, setTrgApiKey] = useState({
    value: "", error: ""
  });
  const [sourceUrl, setSourceUrl] = useState({
    value: "", error: ""
  });
  const [trgUrl, setTrgUrl] = useState({
    value: "", error: ""
  });
  const [user, setUser] = useState({
    value: "", error: ""
  });
  const navigate = useNavigate();
  const Users = useSelector((state) => state.usersSlice.value);
  const Loading = useSelector((state) => state.usersSlice.loading);
  const [nonAdminUser, setNonAdminUser] = useState([]);
  useEffect(() => {
    if (role === "1") {
      if (isObjEmpty(Users)) {
        dispatch(getUsers());
      }

    }
  }, []);
  useEffect(() => {
    if (role === "1") {
      filterAdminUser();
    }

  }, [Users]);

  const filterAdminUser = () => {
    let temp = [...Users];
    temp = temp.filter((item) => {
      return !item.roles.some((item) => {
        return item.id == 1;
      });
    });

    setNonAdminUser(temp);
  };

  const save = () => {
    const nameError = validator(channelName.value);
    const SourceApiNameError = validator(srcApiKeyName.value);
    const SourceApiKeyError = validator(srcApiKey.value);
    const SourceUrlError = validator(sourceUrl.value);
    const SourceNameError = validator(srcName.value);
    const trgNameError = validator(trgName.value);
    const trgUrlError = validator(trgUrl.value);
    const trgApiNameError = validator(trgApiKeyName.value);
    const trgApiKeyError = validator(trgApiKey.value);
    const userError = role === "1" ? validator(user.value) : "";

    if (nameError || SourceApiNameError || SourceApiKeyError || SourceUrlError || SourceNameError || trgNameError || trgUrlError || trgApiNameError || trgApiKeyError || userError) {
      setChannelName({ ...channelName, error: nameError });
      setSrcName({ ...srcName, error: SourceNameError });
      setSrcApiKeyName({ ...srcApiKeyName, error: SourceApiNameError });
      setSrcApiKey({ ...srcApiKey, error: SourceApiKeyError });
      setTrgApiKeyName({ ...trgApiKeyName, error: trgApiNameError });
      setTrgApiKey({ ...trgApiKey, error: trgApiKeyError });
      setSourceUrl({ ...sourceUrl, error: SourceUrlError });
      setTrgUrl({ ...trgUrl, error: trgUrlError });
      setTrgName({ ...trgName, error: trgNameError });
      setUser({ ...user, error: userError });
    }
    else {
      const data1 = {
        name: channelName.value,
        source_name: srcName.value,
        source_api_key_name: srcApiKeyName.value,
        source_url: sourceUrl.value,
        source_api_key: srcApiKey.value,
        target_name: trgName.value,
        target_url: trgUrl.value,
        target_api_key_name: trgApiKeyName.value,
        target_api_key: trgApiKey.value,

        user_id: role === "1" ? user.value : null
      };
      dispatch(createChannel(
        data1
      )).then(() => {
        navigate("/");
      });
    }


  };

  useEffect(() => {

    setUser({ ...user, value: [nonAdminUser[0]?.id] });


  }, [Users]);

  useImperativeHandle(ref, () => ({
    save() {
      save();
    },
  }));
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }


  return (

    <Box className="ContainserDetail">
      <Box sx={{ display: "flex", justifyContent: "space-between", padding: "20px 0px " }}>
        <Box>
          <Typography className="TilteText">Create Channel</Typography>
        </Box>
        <Button className="hover" sx={{ background: "#EC492F", width: "93px", height: "32px" }} onClick={save} >
          <Typography className="button">
            Save
          </Typography>
        </Button>
      </Box>
      {
        Loading ? (null) : (
          <>
            <CollapseDetail Title={"Channel Detail"} >
              <ChannelDetailForm channelName={channelName} setChannelName={setChannelName} user={user} setUser={setUser} users={nonAdminUser} />
            </CollapseDetail>
            <CollapseDetail Title={"Source"} >
              <SourceForm srcName={srcName} setSrcName={setSrcName} srcApiKeyName={srcApiKeyName} setSrcApiKeyName={setSrcApiKeyName} srcApiKey={srcApiKey} setSrcApiKey={setSrcApiKey} sourceUrl={sourceUrl} setSourceUrl={setSourceUrl} />
            </CollapseDetail>
            <CollapseDetail Title={"Target"} >
              <TargetForm trgName={trgName} setTrgName={setTrgName} trgApiKeyName={trgApiKeyName} setTrgApiKeyName={setTrgApiKeyName} trgApiKey={trgApiKey} setTrgApiKey={setTrgApiKey} trgUrl={trgUrl} setTrgUrl={setTrgUrl} />
            </CollapseDetail></>
        )
      }





    </Box >

  );
});
